'use strict';

exports.__esModule = true;
exports.transformPractice = exports.transformRecommendations = exports.transformPracticeSpecialists = exports.transformAllDoctorsReviews = exports.transformOneProfileReviews = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _constats = require('./constats');

var _avatar = require('../../src/assets/avatar.png');

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

var transformOneProfileReviews = exports.transformOneProfileReviews = function transformOneProfileReviews(reviews) {
    return reviews.map(function (review) {
        return {
            date: (0, _moment2.default)(review.timestamp_created).format('DD/MM/YYYY'),
            profileId: review.specialist && review.specialist.id || review.practice && review.practice.id,
            profileType: review.specialist && _constats.QUERY_SPECIALISTS_PROFILE_TYPE || review.practice && _constats.QUERY_PRACTICES_PROFILE_TYPE,
            body: review.review && review.review.body,
            rating: review.aggregate_score,
            isVerified: review.is_verified
        };
    }) || [];
};

var transformAllDoctorsReviews = exports.transformAllDoctorsReviews = function transformAllDoctorsReviews(reviews) {
    return reviews.map(function (review) {
        return {
            date: (0, _moment2.default)(review.timestamp_created).format('DD/MM/YYYY'),
            profileId: review.specialist,
            profileType: _constats.QUERY_SPECIALISTS_PROFILE_TYPE,
            body: review.specialist_review && review.specialist_review.body,
            rating: review.specialist_aggregate_review,
            isVerified: review.is_verified
        };
    }) || [];
};

var transformPracticeSpecialists = exports.transformPracticeSpecialists = function transformPracticeSpecialists(specialists) {
    specialists = specialists.filter(function (item) {
        return item.specialist && item.specialist.status && item.specialist.status === "approved";
    });
    var transformed = specialists.map(function (specialist) {
        return {
            id: specialist.specialist && specialist.specialist.id,
            uri_id: specialist.specialist && specialist.specialist.uri_id,
            name: (specialist.specialist && specialist.specialist.firstname) + ' ' + (specialist.specialist && specialist.specialist.lastname),
            title: specialist.specialist && capitalize(specialist.specialist.title),
            totalReviews: specialist.specialist && specialist.specialist.number_of_reviews,
            totalRecommendations: specialist.specialist && specialist.specialist.number_of_recommendations,
            profileImage: specialist.specialist && specialist.specialist.attributes && specialist.specialist.attributes.profile_featured_image && specialist.specialist.attributes.profile_featured_image + '_lg.jpg' || _avatar2.default
        };
    }) || [];

    transformed.sort(function (a, b) {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
    return transformed;
};

var transformRecommendations = exports.transformRecommendations = function transformRecommendations(recommendations) {
    return recommendations.map(function (recommendation) {
        var speciality = recommendation.keywords.find(function (item) {
            return item.keyword_type === "specialty";
        });
        return {
            id: recommendation.id,
            recommender: {
                name: capitalize(recommendation.recommender_title + ' ' + recommendation.recommender_firstname + ' ' + recommendation.recommender_lastname),
                image: recommendation.recommender_profile_image && recommendation.recommender_profile_image + '_lg.jpg' || _avatar2.default,
                uri_id: recommendation.recommender_uri_id
            },
            recommendee: {
                name: capitalize(recommendation.recommendee_title + ' ' + recommendation.recommendee_firstname + ' ' + recommendation.recommendee_lastname),
                image: recommendation.recommendee_profile_image && recommendation.recommendee_profile_image + '_lg.jpg' || _avatar2.default,
                uri_id: recommendation.recommendee_uri_id
            },
            content: recommendation.recommendation,
            connection: recommendation.connection,
            speciality: speciality && speciality.name || undefined,
            date: (0, _moment2.default)(recommendation.timestamp_created).format('DD/MM/YYYY')
        };
    }) || [];
};

var transformPractice = exports.transformPractice = function transformPractice(practice) {
    return {
        uriId: practice.uri_id,
        id: practice.id,
        name: practice.name,
        averageRating: practice.average_review,
        totalReviews: practice.number_of_reviews,
        profileImage: practice.attributes.profile_logo && practice.attributes.profile_logo + '_lg.jpg' || null
    };
};